/**
 * @file Route: webinarstraining
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import Header from "components/Header/Pro";
import "components/Intro/dark";
import "components/Nav";
import VideosOverview from "components/VideosOverview";
import "components/Calendar";
import "./index.scss";

console.log("Route webinarstraining/index.js mounted.");

Header();
VideosOverview("knowledge");
VideosOverview("webinars");
/* VideosOverview("presentations");
VideosOverview("trainingvideos"); */

